// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/pressure-spring/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produktePressureSpringEN: PageEntry = {
  id: "example.produkte-anpressfeder",
  locale: "en",
  slug: "produkte/pressure-spring",
  seo: {
    title: "Pressure spring | Dietz GmbH",
    description: "Compensation of length tolerances in a seat assembly installed in the vehicle. Lowest material consumption due to a progressive composite concept without pilot strips.",
  },
  type: "post",
  h1: "Pressure spring",
  intro: "Compensation of length tolerances in a seat assembly installed in the vehicle. Lowest material consumption due to a progressive composite concept without pilot strips.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_anpressfeder.jpg", alt: "Pressure spring", width: 800, height: 640 }
  ],
};
